export const CUSTOM_VISUAL_DEFAULTS = Object.freeze({
  background: Object.freeze({ color: "#FFFFFF", imageUrl: "", imagePosition: "center", imageSize: "cover" }),
  layout: Object.freeze({ spacingScale: 0.88 }),
  eyebrow: Object.freeze({ color: "#F35A3A", fontWeight: 900, letterSpacing: 0.14 }),
  title: Object.freeze({ color: "#19242F", fontScale: 0.9, fontWeight: 900 }),
  description: Object.freeze({ color: "#5B5D73", lineHeight: 1.75 }),
  image: Object.freeze({ backgroundColor: "transparent", borderColor: "transparent", borderWidth: 0, borderRadius: 32, shadowColor: "#000000", shadowOpacity: 0, shadowX: 0, shadowY: 0, shadowBlur: 0, shadowSpread: 0, heightMobile: 260, heightDesktop: 343, objectFit: "cover" }),
  cta: Object.freeze({ backgroundColor: "#F35A3A", textColor: "#FFFFFF", hoverBackgroundColor: "#D94D32", hoverTextColor: "#FFFFFF", borderColor: "transparent", borderWidth: 0, borderRadius: 999, shadowColor: "#000000", shadowOpacity: 0, shadowX: 0, shadowY: 0, shadowBlur: 0, shadowSpread: 0, focusColor: "rgba(243,90,58,.35)", fontWeight: 900 }),
  youtube: Object.freeze({ backgroundColor: "#000000", borderColor: "transparent", borderWidth: 0, borderRadius: 32, shadowColor: "#000000", shadowOpacity: 0, shadowX: 0, shadowY: 0, shadowBlur: 0, shadowSpread: 0 }),
  calendly: Object.freeze({ backgroundColor: "#FFFFFF", borderColor: "transparent", borderWidth: 0, borderRadius: 32, shadowColor: "#000000", shadowOpacity: 0, shadowX: 0, shadowY: 0, shadowBlur: 0, shadowSpread: 0, heightMobile: 680, heightDesktop: 760 }),
});

const objectValue = (value) => value && typeof value === "object" && !Array.isArray(value) ? value : {};
export function normalizeCustomSegmentStyle(style = {}) {
  const source = objectValue(style);
  const custom = objectValue(source.custom);
  return {
    background: { ...CUSTOM_VISUAL_DEFAULTS.background, ...objectValue(source.background) },
    custom: {
      layout: { ...CUSTOM_VISUAL_DEFAULTS.layout, ...objectValue(custom.layout) },
      eyebrow: { ...CUSTOM_VISUAL_DEFAULTS.eyebrow, ...objectValue(custom.eyebrow) },
      title: { ...CUSTOM_VISUAL_DEFAULTS.title, ...objectValue(custom.title) },
      description: { ...CUSTOM_VISUAL_DEFAULTS.description, ...objectValue(custom.description) },
      image: { ...CUSTOM_VISUAL_DEFAULTS.image, ...objectValue(custom.image) },
      cta: { ...CUSTOM_VISUAL_DEFAULTS.cta, ...objectValue(custom.cta) },
      youtube: { ...CUSTOM_VISUAL_DEFAULTS.youtube, ...objectValue(custom.youtube) },
      calendly: { ...CUSTOM_VISUAL_DEFAULTS.calendly, ...objectValue(custom.calendly) },
    },
  };
}

function alphaColor(color, opacity) {
  const raw = String(color || "").trim();
  if (!raw || Number(opacity) <= 0) return "transparent";
  if (Number(opacity) >= 1) return raw;
  const hex = raw.match(/^#([0-9a-f]{6})$/i)?.[1];
  if (!hex) return raw;
  return `rgba(${parseInt(hex.slice(0,2),16)}, ${parseInt(hex.slice(2,4),16)}, ${parseInt(hex.slice(4,6),16)}, ${Number(opacity)})`;
}
export function customShadow(style = {}) {
  const opacity = Number(style.shadowOpacity) || 0;
  if (opacity <= 0) return "none";
  return `${Number(style.shadowX)||0}px ${Number(style.shadowY)||0}px ${Math.max(0,Number(style.shadowBlur)||0)}px ${Number(style.shadowSpread)||0}px ${alphaColor(style.shadowColor || "#000000", opacity)}`;
}
